var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBestsellersSmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 56 56"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  clipPath: "url(#bestsellersSmall_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M16.1 4.8a2 2 0 0 1 2-2h19.8a2 2 0 0 1 2 2V21c0 6.572-5.328 11.9-11.9 11.9S16.1 27.572 16.1 21z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M31.5 4.9h7.7M28 42h5.6M31.5 7h7.7M29.4 44.1h4.2M31.5 9.1h7.7M29.4 46.2h4.2M31.5 11.2h7.7M29.4 48.3h4.2M31.5 13.3h7.7M31.5 15.4h7.7M31.5 17.5h7.7M31.5 19.6h7.7M31.5 21.7h7.7M31.5 23.8h7.7M30.8 25.9h7.7M30.1 28h8.4M28.7 30.1h7.7"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M22.4 49.7h11.2v-5.8a4 4 0 0 0-4-4h-3.2a4 4 0 0 0-4 4z"
}), /*#__PURE__*/React.createElement("path", {
  strokeWidth: 2,
  d: "M17.5 52.811c0 .215.174.389.389.389h20.405a.206.206 0 0 0 .206-.206 3.294 3.294 0 0 0-3.294-3.294H20.61a3.11 3.11 0 0 0-3.111 3.111ZM25.2 32.9h5.6v7h-5.6zM16.1 8.4h-5.34a2 2 0 0 0-1.972 2.329l.791 4.747A6.61 6.61 0 0 0 16.1 21M39.9 8.4h5.34a2 2 0 0 1 1.972 2.329l-.791 4.747A6.61 6.61 0 0 1 39.9 21"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "bestsellersSmall_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h56v56H0z"
})))));
export default SvgBestsellersSmall;